// document.addEventListener('scroll', function () {
//   const bar = document.querySelector('.announcement-bar'); // Announcement bar ko select karo
//   if (window.scrollY > 50) { // Jab scroll 50px se zyada ho
//     bar.classList.add('scrolled'); // "scrolled" class add karo
//   } else {
//     bar.classList.remove('scrolled'); // Class remove karo agar scroll kam ho
//   }
// });

document.addEventListener('scroll', function () {
  const announcementBar = document.querySelector('.announcement-bar'); // Announcement bar ko select karo
  const headerWrapper = document.querySelector('.header-wrapper'); // Header wrapper ko select karo

  // Announcement bar ke liye scroll check karo
  if (window.scrollY > 50) {
    announcementBar.classList.add('scrolled'); // Announcement bar ko sticky bana do
  } else {
    announcementBar.classList.remove('scrolled'); // Agar scroll 50px se kam ho to class remove karo
  }

  // Header wrapper ke liye scroll check karo
  if (window.scrollY > 50) {
    headerWrapper.classList.add('scrolled'); // Header ko sticky bana do
  } else {
    headerWrapper.classList.remove('scrolled'); // Agar scroll 50px se kam ho to class remove karo
  }
});
